import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { KycDocumentsResponse } from './types/Kyc';

export type DeleteKycDocumentsPayload = (
  userId: 'me' | number,
  kycUuid: string,
  data: { documentUuid: string },
) => Promise<{ data: KycDocumentsResponse }>;

export default (makeCall: MakeCall): DeleteKycDocumentsPayload =>
  (userId, kycUuid, data) =>
    makeCall<KycDocumentsResponse>(
      'DELETE',
      `${APIV2_URL}/user/${userId}/kyc/${kycUuid}/documents`,
      { data },
    );
